import clsx from 'clsx';
import type { ReactNode } from 'react';

interface PillButtonProps {
	active: boolean;
	onClick: () => void;
	children: ReactNode;
}

export const PillButton = ({ active, onClick, children }: PillButtonProps) => (
	<button
		className={clsx(
			'px-space-12 py-space-6 rounded-full text-sm-medium border transition-colors cursor-pointer whitespace-nowrap',
			active
				? 'bg-brand-secondary-50 border-brand-secondary-600 text-brand-secondary-700'
				: 'bg-white border-neutral-200 text-neutral-600 hover:border-neutral-400',
		)}
		onClick={onClick}
		type="button"
	>
		{children}
	</button>
);
